import { IApiService } from "services/models/ApiService";
import { MockEmployeeApiService } from "./MockEmployeeApiService";
import { MockHostApiService } from "./MockHostApiService";
import { MockOpenApiService } from "./MockOpenApiService";
import { MockPlayerApiService } from "./MockPlayerApiService";
import { MockPreferencesApiService } from "./MockPreferencesApiService";

class MockApiService implements IApiService {
  host = new MockHostApiService();
  player = new MockPlayerApiService();
  preferences = new MockPreferencesApiService();
  open = new MockOpenApiService();
  employee = new MockEmployeeApiService();
}

export default MockApiService;
